function corrigirTamanhoMenuMatricule(){
  const container = $('#ensino-medio-matricular > div.container');
  if (!container.length) return;
  const left = container.offset().left;
  $('#ensino-medio-matricular ul.links').css('width', ((left + container.width()) - ($('#novos').width() + 5))+'px')
}

corrigirTamanhoMenuMatricule();
$( window ).resize(function() {
  corrigirTamanhoMenuMatricule();
});

$('.field--name-field-emaee-fotos').slick({
  autoplay: true,
});

$('#emm-links li').on('click', function(){
  const target = $(this).data('target');
  if (!target) throw new Error('era para ter target');
  $('.emm-links__tab').hide();
  $(target).show();
  $('#emm-links li').removeClass('selected');
  $(this).addClass('selected');
});
